import { Col, Form, Input, Row } from "antd";
import { FormInstance } from "antd/lib/form";
import React from "react";

type FormType = {
  form: FormInstance<any>;
  values?: any;
  submit: (values: any) => void;
  data: any;
};

export const PriceListForm: React.FC<FormType> = (props) => {
  const { form, values, submit } = props;

  const onFinish = (values: any) => {
    const input = {
      ...values,
    };
    submit(input);
  };

  return (
    <Form layout="vertical" form={form} initialValues={values} onFinish={onFinish}>
      <Row gutter={[24, 0]}>
        <Col span={12}>
          <Form.Item name="code" label="Code" rules={[{ required: true, message: "is required" }]}>
            <Input />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};
